exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../../node_modules/css-loader/index.js!vue-directive-tooltip/css/index.css"), "");

// module
exports.push([module.id, ".edit-sub-frequency[data-v-15738414] {\n  padding-bottom: 3em;\n}\n.edit-sub-frequency .freq-input[data-v-15738414] {\n  margin-bottom: 2em;\n}\n", ""]);

// exports
